import axios from 'axios';
import { base_url } from '../../../api/api-url';
import { getAuthHeaders } from '../../../utility/getAuthHeaders';


const API_URL = base_url;

// const getAuthHeaders = () => {
//   const token = localStorage.getItem('authToken'); 
//   return {
//     headers: {
//       Authorization: token,
//     },
//   };
// };

export const fetchVendors = () => axios.get(`${API_URL}/vendor`, getAuthHeaders());

export const createVendor = (data) =>
  axios.post(`${API_URL}/vendor`, data, getAuthHeaders());

export const updateVendor = (id, data) =>
  axios.put(`${API_URL}/vendor/${id}`, data, getAuthHeaders());

export const deleteVendor = (id) =>
  axios.delete(`${API_URL}/vendor/${id}`, getAuthHeaders());

export const getRegisterVendor = (id) =>
  axios.get(`${API_URL}/registervendor/${id}`, getAuthHeaders());
export const getRegisterEventVendor = (id) =>
  axios.get(`${API_URL}/event-vendor/${id}`, getAuthHeaders());

